.started-from-container {
    max-width: 400px;
    overflow: hidden;
}

.banner-icon {
    vertical-align: middle;
    margin-right: 4px;
}
